<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close"><i class="fa fa-exclamation-triangle"></i>&nbsp; Accept Download Charge for {{ charges.downloadFormat }}</modal-header>
        </div>
        <p v-if="charges.alreadyDownloaded">The unit has previously been charged for.</p>
        <p v-else>In requesting the {{ charges.downloadFormat }} for download your account will be charged for 1 new download.</p>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="Cancel Download request" confirmText="Accept Charge and Download" confirmTheme="danger" />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_charge_single_confirmation',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    charges: Object
  },
  data: () => ({}),
  mounted () {},
  computed: {
    charge () {
      const value = this.charges.totalDownloads * this.charges.downloadCost
      return Math.max(0, value)
    }
  },
  methods: {
    confirm () {
      this.$emit('downloadFile', this.charges.downloadFormat)
      this.close()
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-charge-single-confirmation.vue